export default [
    {
        path: '/occupancy-consolidations',
        name: 'occupancy-consolidations',
        component: () => import('./pages/Index'),
        meta: {
            title: 'Consolidação de Ocupação',
            icon: 'mdi-file-pdf-box',
            breadcrumbs: [
                { text: 'Consolidação de Ocupação', disabled: true }
            ]
        }
    }
]
